<template>
  <div class="progress">
    <a-progress :percent="preparedPercent()" />
  </div>
</template>

<script>
export default {
  name: 'ComponentPrepareProgress',

  props: {
    percent: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    preparedPercent() {
      let res = 0;
      if (this.percent) {
        Object.keys(this.percent).forEach((key) => {
          if (typeof this.percent[key] === 'number') {
            res = this.percent[key];
          } else {
            Object.keys(this.percent[key]).forEach((i) => {
              if (typeof this.percent[key][i] === 'number') {
                res = this.percent[key][i];
              }
            });
          }
        });
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  width: 100%;
}
</style>
